import React from 'react'
import PropTypes from 'prop-types'

export const EditIcon = ({ width = '24', height = '24', type = 'bold', invert, ...rest }) => {
	const color = invert ? '#ffffff' : '#566B76'

	if (type === 'bold') {
		return (
			<svg width={width} height={height} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...rest}>
				<path
					fillRule="evenodd"
					clipRule="evenodd"
					d="M22.162 5.46218L23.2495 4.37467C24.2489 3.3753 24.2489 1.74966 23.2495 0.751319C22.7647 0.268548 22.122 0 21.4373 0C20.7526 0 20.109 0.268548 19.6252 0.751319L18.5376 1.83781L22.162 5.46218ZM0.150203 23.8494C0.303952 24.0032 0.53765 24.0462 0.741623 23.9458L6.20996 21.2121L2.78853 17.7897L0.0538534 23.258C-0.0445458 23.4558 -0.00559613 23.6936 0.150203 23.8494ZM21.4375 6.18665L7.03538 20.5878L3.41204 16.9644L17.8132 2.56228L21.4375 6.18665Z"
					fill={color}
				/>
			</svg>
		)
	} else {
		return (
			<svg width={width} height={height} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...rest}>
				<path
					fillRule="evenodd"
					clipRule="evenodd"
					d="M3.05178 17.325C3.0095 17.3673 2.97616 17.4152 2.95176 17.4662L0.0563098 23.2561C-0.163971 23.6966 0.303301 24.1639 0.743816 23.9437L6.53174 21.0503C6.58363 21.0258 6.63227 20.9921 6.67519 20.9492L6.67875 20.9456L21.7925 5.83182L21.8013 5.82325L21.8098 5.81447L23.2506 4.37373C24.2501 3.37169 24.2501 1.75119 23.2508 0.750665C22.2499 -0.250222 20.6256 -0.250222 19.626 0.750665L18.1948 2.18194C18.1887 2.18743 18.1828 2.19309 18.177 2.19893C18.1711 2.20476 18.1655 2.2107 18.16 2.21674L3.05178 17.325ZM6.31289 19.8619L20.714 5.46074L18.5397 3.28642L4.13896 17.6872L6.31289 19.8619ZM5.44779 20.4462L3.55455 18.5523L1.66064 22.3394L5.44779 20.4462ZM22.5254 3.6494L21.4388 4.73599L19.2645 2.56168L20.351 1.47514C20.9505 0.874825 21.9255 0.874825 22.5258 1.47514C23.1253 2.07535 23.1253 3.04796 22.5254 3.6494Z"
					fill={color}
				/>
			</svg>
		)
	}
}

EditIcon.propTypes = {
	type: PropTypes.oneOf(['bold', 'light']),
	invert: PropTypes.bool,
	onClick: PropTypes.func,
}
